import React, { useRef, useState } from "react";

import "./styles/common.css?ver=1";
import { Link } from "react-router-dom";
import button from "./assets/x.png";

function Footer() {
  const [openModal, setOpenModal] = useState(false);
  const modalBackground = useRef<HTMLDivElement>(null);

  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div>
      <section className="sec-footer">
        <div className="ft-wr">
          <div className="wr">
            <div className="ft-link">
              <div className="ft-wrapper">
                <Link to="/abt_overview" onClick={handleLinkClick}>
                  회사소개
                </Link>
                <p className="ft-line">｜</p>
                <p className="btn-wrapper" onClick={() => setOpenModal(true)}>
                  이메일무단수집거부
                </p>
              </div>
            </div>
            {openModal && (
              <div
                className="modal-container"
                ref={modalBackground}
                onClick={(e) => {
                  if (e.target === modalBackground.current) {
                    setOpenModal(false);
                  }
                }}
              >
                <div className="modal-content">
                  <p className="modal-title">이메일무단수집거부</p>
                  <div className="modal-text">
                    본 웹사이트는 게시된 이메일 주소가 전자우편 수집
                    프로그램이나 그 밖의 기술적 장치를 이용하여 무단 수집되는
                    것을 거부합니다. 이를 위반 시 『정보통신망 이용 촉진 및
                    정보보호 등에 관한 법률』등에 의해 처벌받을 수 있습니다.
                  </div>
                  <div className="modal-image-container">
                    <img
                      src={button}
                      alt="Close modal"
                      onClick={() => setOpenModal(false)}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="ft-info">
              <p>
                주식회사 제닉스 ｜ 주소 : 서울시 영등포구 영신로 166
                반도아이비밸리 413호
                <br />
                Tel : 02-861-4716 ｜ Email : kissis@jenixinfo.co.kr
              </p>
              <p className="copy">
                Copyright © 2024 JENIX. All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Footer;
